import React, { Component } from 'react';

import loginPageCss from "../css/loginPage.module.css";
import "../css/loginPage.css"

import JoinHeader from "../component/JoinHeader";
import MarketingConsentToggleModal from "../modal/MarketingConsentToggleModal";

import * as apiUtil from "../../../util/apiUtil";

import * as registerAction from '../store/register';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Footer from "../../../component/layout/Footer";

class JoinAgreeContainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            marketingConsentModal: null, // { channel, agreed } | null
        };

        this.handleAgreeAll = this.handleAgreeAll.bind(this);
        this.handleAgreeOptionalAll = this.handleAgreeOptionalAll.bind(this);
        this.handleAgree = this.handleAgree.bind(this);
        this.handleAgreeOptional = this.handleAgreeOptional.bind(this);
        this.closeMarketingConsentModal = this.closeMarketingConsentModal.bind(this);
        this.goNextPage = this.goNextPage.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return (
            this.props.agree !== nextProps.agree
            || this.props.agreeOptional !== nextProps.agreeOptional
            || this.state.marketingConsentModal !== nextState.marketingConsentModal
        )
    }

    closeMarketingConsentModal() {
        this.setState({ marketingConsentModal: null });
    }

    handleAgreeAll(e) {
        const { RegisterAction } = this.props;
        if (e.target.checked) {
            RegisterAction.setAgreeAll();
        } else {
            RegisterAction.setDisagreeAll();
        }
    }

    handleAgree(e) {
        const { RegisterAction } = this.props;
        RegisterAction.setAgree({ [e.target.name]: e.target.checked });
    }

    handleAgreeOptionalAll(e) {
        const { RegisterAction } = this.props;
        const agreed = e.target.checked;
        if (agreed) {
            RegisterAction.setAgreeOptionalAll();
        } else {
            RegisterAction.setDisagreeOptionalAll();
        }
        this.setState({ marketingConsentModal: { channel: 'recv', agreed } });
    }

    handleAgreeOptional(e) {
        const { RegisterAction } = this.props;
        const { name, checked } = e.target;
        RegisterAction.setAgreeOptional({ [name]: checked });
        this.setState({ marketingConsentModal: { channel: name, agreed: checked } });
    }

    goNextPage() {
        const { agree, agreeOptional } = this.props;
        const { hstate } = this.props;

        if (! (agree.service && agree.personal && agree.spam)) {
            alert("(필수 동의항목) 약관 동의 후 다음 절차를 진행 할 수 있습니다.");
            return;
        }

        apiUtil.asyncRequest({
            url: `/api/auth/agree`,
            method: apiUtil.requestMethod.POST,
            data: {
                mandatory: agree,
                optional:  agreeOptional,
            },
            success: (result) => {
                let url = "/register/info";

                url += `?jToken=${encodeURIComponent(result.tokenJoin)}`;

                if (result.termsMail) url += `&tMail=${result.termsMail}`;
                if (result.termsMms) url += `&tMms=${result.termsMms}`;
                if (result.termsKakao) url += `&tKakao=${result.termsKakao}`;
                if (hstate) url += `&hstate=${hstate}`;

                window.location.href = url;
            }
        })
    }

    render() {
        const { agree, agreeOptional } = this.props;
        const { hstate } = this.props;
        const { marketingConsentModal } = this.state;
        const { handleAgreeAll, handleAgree, handleAgreeOptionalAll, handleAgreeOptional, closeMarketingConsentModal, goNextPage } = this;

        return (
            <>
                <JoinHeader
                    joinStep={1}
                    hstate={hstate}
                >
                    <div className='row align-items-center justify-content-center'>
                        <div className={`card card-body p-lg-5 position-relative ${loginPageCss["agree-form"]}`}>
                            <h1 className='fs-4 fw-bold'>이용약관 동의</h1>
                            <div className={`d-flex ${loginPageCss["d-flex"]} pb-1`}>
                                <input className={`form-check-input ${loginPageCss["form-check-input"]}`} id="allAgree" type="checkbox" onChange={handleAgreeAll} checked={(agree.spam && agree.personal && agree.service && agreeOptional.recvMms && agreeOptional.recvMail && agreeOptional.recvKakao)}/>
                                <label htmlFor="allAgree" className={`fs-4`}>전체 동의 합니다.</label>
                            </div>
                            <small className='text-primary ps-4 fw-normal'>이용약관, 개인정보 수집 이용, 스팸 정책, 마케팅 수집 및 활용에 모두 동의 합니다.</small>
                            <hr className=''></hr>

                            <div>
                                <div className={`d-flex align-items-center justify-content-between ${loginPageCss["d-flex"]}`}>
                                    <div className={`d-flex ${loginPageCss["d-flex"]}`}>
                                        <input className={`form-check-input ${loginPageCss["form-check-input"]}`} id="service" name={"service"} type="checkbox" checked={agree.service} onChange={handleAgree}/>
                                        <label htmlFor="service">비즈팅 서비스 이용약관 동의 (필수)</label>
                                    </div>
                                    <a href="/clause/use" target="_blank" rel="noopener noreferrer" className="text-primary text-decoration-none">
                                        보기 <img style={{ width: '10px' }} src="/assets/img/external-link-blue.svg" alt="external-link" />
                                    </a>
                                </div>
                            </div>

                            <div>
                                <div className={`d-flex align-items-center justify-content-between ${loginPageCss["d-flex"]}`}>
                                    <div className={`d-flex ${loginPageCss["d-flex"]}`}>
                                        <input className={`form-check-input ${loginPageCss["form-check-input"]}`} id="personal" name={"personal"} type="checkbox" checked={agree.personal} onChange={handleAgree}/>
                                        <label htmlFor="personal">개인정보 수집 및 이용 동의 (필수)</label>
                                    </div>
                                    <a href="/clause/privacy" target="_blank" rel="noopener noreferrer" className="text-primary text-decoration-none">
                                        보기 <img style={{ width: '10px' }} src="/assets/img/external-link-blue.svg" alt="external-link" />
                                    </a>
                                </div>
                                <div className='agree-wrap'>
                                    <div className="agree-box" tabIndex="1">
                                        <div className="terms-wrap">
                                            <div className="sec">
                                                <p>비즈팅은 회원가입 및 서비스 제공을 위해 다음과 같이 개인정보를 수집·이용합니다.</p>
                                            </div>
                                            <div className="sec">
                                                <h3>가. 회원가입 및 계정 관리</h3>
                                                <table className="table table-bordered table-sm" style={{ fontSize: '12px' }}>
                                                    <thead>
                                                        <tr>
                                                            <th>수집목적</th>
                                                            <th>수집항목</th>
                                                            <th>수집 및 이용목적</th>
                                                            <th>보유기간</th>
                                                            <th>법적근거</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td rowSpan={2}>회원가입 및 계정 관리</td>
                                                            <td>[필수] 회사명, 사업자번호, 주소, 사업자등록증, 업태, 업종, 서비스 담당자 정보(아이디, 비밀번호, 휴대폰번호, 이름, 이메일), 법인명(국문 - 개인사업자 제외)</td>
                                                            <td>회원가입 의사 확인, 서비스 이용 자격 유지·관리, 부정이용 방지, 중복가입 확인</td>
                                                            <td>회원 탈퇴 시까지 단, 부정이용기록(ID): 1년</td>
                                                            <td>개인정보 보호법 제15조(계약 체결·이행) 제1항 제4호</td>
                                                        </tr>
                                                        <tr>
                                                            <td>CI</td>
                                                            <td>본인 식별·인증</td>
                                                            <td>본인인증 처리 후 즉시 파기</td>
                                                            <td>개인정보 보호법 제15조(계약 체결·이행) 제1항 제4호</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="sec">
                                                <h3>나. 서비스 이용에 따라 자동으로 생성·수집되는 정보</h3>
                                                <table className="table table-bordered table-sm" style={{ fontSize: '12px' }}>
                                                    <thead>
                                                        <tr>
                                                            <th>수집항목</th>
                                                            <th>수집 및 이용목적</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>IP Address, 쿠키(Cookie), 방문일시, 서비스 이용 기록, 불량 이용 기록, ID, 접속 시간, 인증 시간, 접속 경로</td>
                                                            <td>접속 관리, 부정 이용 방지, 이용환경 분석 및 서비스 품질 개선</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="sec">
                                                <h3>동의 거부 및 철회에 관한 안내</h3>
                                                <p>귀하는 위 개인정보 수집·이용에 대한 동의를 거부할 권리가 있으며, 동의 후에도 회원 탈퇴를 통해 동의를 철회할 수 있습니다. 다만, 위 개인정보는 비즈팅 회원가입 및 서비스 제공에 필요한 필수 정보이므로, 동의를 거부하거나 철회할 경우 회원가입 또는 서비스 이용이 제한될 수 있습니다.</p>
                                            </div>
                                            <div className="sec d-flex align-items-center justify-content-between">
                                                <p className="mb-0">개인정보 처리에 관한 자세한 사항은 비즈팅 개인정보처리방침에서 확인할 수 있습니다.</p>
                                                <a href="/clause/privacy" target="_blank" rel="noopener noreferrer" className="text-primary text-decoration-none flex-shrink-0 ms-2" style={{ fontSize: '12px' }}>
                                                    개인정보처리방침 <img style={{ width: '8px' }} src="/assets/img/external-link-blue.svg" alt="external-link" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div className={`d-flex align-items-center justify-content-between ${loginPageCss["d-flex"]}`}>
                                    <div className={`d-flex ${loginPageCss["d-flex"]}`}>
                                        <input className={`form-check-input ${loginPageCss["form-check-input"]}`} id="spam" name={"spam"} type="checkbox" checked={agree.spam} onChange={handleAgree}/>
                                        <label htmlFor="spam">스팸제한 정책 동의 (필수)</label>
                                    </div>
                                    <a href="/clause/spam" target="_blank" rel="noopener noreferrer" className="text-primary text-decoration-none">
                                        보기 <img style={{ width: '10px' }} src="/assets/img/external-link-blue.svg" alt="external-link" />
                                    </a>
                                </div>
                            </div>

                            <div>
                                <div className={`d-flex ${loginPageCss["d-flex"]}`}>
                                    <input className={`form-check-input ${loginPageCss["form-check-input"]}`} id="recv" name={"recv"} type="checkbox" checked={agreeOptional.recvMms && agreeOptional.recvMail && agreeOptional.recvKakao} onChange={handleAgreeOptionalAll}/>
                                    <label htmlFor="recv">마케팅 수집 및 활용 동의 (선택)</label> <br/>
                                </div>
                                <div className='agree-wrap'>
                                    <div className="agree-box" tabIndex="2">
                                        <div className="terms-wrap">
                                            <div className="sec">
                                                <p className="mb-0">1. 수집 목적 : 이벤트, 프로모션 및 맞춤형 서비스 정보 제공</p>
                                                <p className="mb-0">2. 수집 항목 : 이름, 연락처, 이메일 주소</p>
                                                <p className="mb-0">3. 보유 및 이용 기간 : <b>동의 철회 시 또는 회원 탈퇴 시</b></p>
                                                <p className="mb-0">4. 동의 거부권 : 귀하는 마케팅 수집 및 활용 동의를 거부할 수 있으며, 동의하지 않아도 서비스 이용에는 제한이 없습니다.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="agree-box border-0 pt-0" tabIndex="2">
                                        <div className="terms-wrap">
                                            <div className={`${loginPageCss["checkbox"]}`}>
                                                <input type="checkbox" id='recvMms' name='recvMms' checked={agreeOptional.recvMms} onChange={handleAgreeOptional} />
                                                <label htmlFor="recvMms"><span>이벤트 및 혜택 SMS 수신</span></label>
                                            </div>
                                            <div  className={`${loginPageCss["checkbox"]}`}>
                                                <input type="checkbox" id='recvMail' name='recvMail' checked={agreeOptional.recvMail} onChange={handleAgreeOptional} />
                                                <label htmlFor='recvMail'><span>이벤트 및 혜택 E-Mail 수신</span></label>
                                            </div>
                                            <div className={`${loginPageCss["checkbox"]}`}>
                                                <input type="checkbox" id='recvKakao' name='recvKakao' checked={agreeOptional.recvKakao} onChange={handleAgreeOptional} />
                                                <label htmlFor='recvKakao'><span>이벤트 및 혜택 카카오톡 수신</span></label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={`d-flex ${loginPageCss["d-flex"]} justify-content-center`}>
                                <button
                                    onClick={goNextPage}
                                    type="button"
                                    disabled={!(agree.spam && agree.personal && agree.service)}
                                    className={"w-50 btn btn-primary btn-md mt-3"}
                                >다음
                                    <span className="material-symbols-rounded align-middle ms-1 fs-5">arrow_forward</span>
                                </button>
                            </div>
                            <div>
                                {
                                    (agree.spam && agree.personal && agree.service) ||
                                    <p className={"text-danger mb-0 text-center fs-6"}>(필수 동의 항목) 약관 동의 후 다음 절차를 진행 할 수 있습니다!</p>
                                }
                            </div>
                            <div className={loginPageCss["bottom-line"]}></div>
                        </div>
                    </div>
                </JoinHeader>
                <Footer />
                <MarketingConsentToggleModal
                    isOpen={!!marketingConsentModal}
                    onRequestClose={closeMarketingConsentModal}
                    channel={marketingConsentModal?.channel}
                    agreed={marketingConsentModal?.agreed}
                />
            </>
        )
    }
}

export default connect(
    (state) => ({
        agree: state.register.agree,
        agreeOptional: state.register.agreeOptional,
    }),
    (dispatch) => ({
        RegisterAction: bindActionCreators(registerAction, dispatch),
    })
)(JoinAgreeContainer);
